import * as React from "react";
const SvgFiRrOnion = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-onion_svg__a)">
      <path
        fill="#062147"
        d="M24 13c0-5.675-4.866-8.712-8-9.745A3.026 3.026 0 0 0 13 0h-2a3.026 3.026 0 0 0-3 3.255C-1.667 6.134-3.988 19.441 9.056 21.761l-.61.407A1.006 1.006 0 0 0 9 24c.447.066 1.627-.94 2-1.132a1.005 1.005 0 1 0 2 0c.381.2 1.546 1.2 2 1.132a1.005 1.005 0 0 0 .556-1.832l-.61-.407C20.4 20.876 24 17.525 24 13M10 3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1c.006.263.11.515.291.706A14.42 14.42 0 0 1 18.001 14a5.58 5.58 0 0 1-2.615 4.821c2.074-5.833-1.453-12.669-2.679-13.528a1 1 0 0 0-1.414 0c-1.228.862-4.753 7.7-2.679 13.528C2.69 15.092 8.468 5.562 9.707 4.707c.182-.191.287-.443.293-.707zm0 12a13.45 13.45 0 0 1 2-7.354A13.45 13.45 0 0 1 14 15c0 2.088-.76 5-2 5s-2-2.912-2-5m-8-2a7.7 7.7 0 0 1 4.072-6.644C4.4 8.989 2.8 15.252 5.362 18.4A6.09 6.09 0 0 1 2 13m16.638 5.4c2.561-3.146.958-9.4-.71-12.039C22.3 8.635 24 15.494 18.638 18.4"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-onion_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrOnion;
